import { registerActions } from "../actionRegistry";
/**
 * UI Toggle Functions
 *
 * Simple show/hide/toggle operations for various UI elements.
 */

import { getDomElement, setHtml, show, hide, addClass, removeClass } from "../utils/dom";
import { setTransferShow } from "../globalState";
import { refreshTransfers } from "./transfers";
import { setCookie } from "./cookies";
import { editnotes } from "./gallery";

/**
 * Toggle mobile menu visibility
 */
export function togglemobilemenu(): void {
  const menu = getDomElement("menu-mobile");
  if (!menu) return;

  if (menu.style.bottom === "0px") {
    menu.style.bottom = "-100vh";
  } else {
    menu.style.bottom = "0px";
  }
}

/**
 * Cancel notes editing and restore original content
 */
export function cancelnotes(id: string): void {
  const oldNotes = getDomElement<HTMLInputElement>(`oldnotes-${id}`)?.value ?? "";
  const container = getDomElement(`notes-${id}`);
  if (!container) return;

  // The note is user-entered text. It used to be interpolated into an innerHTML
  // string alongside the static placeholder markup, so a note containing
  // `<img src=x onerror=…>` executed on every render — stored XSS. The two halves
  // are separated now: the placeholder is markup, the note never is.
  const div = document.createElement("div");
  if (oldNotes) {
    div.textContent = oldNotes;
  } else {
    div.innerHTML = '<span style="color: #aaa;"><i>No notes added</i></span>';
  }
  container.replaceChildren(div);
  div.addEventListener("click", () => void editnotes(id));
}

/**
 * Expand/collapse transfers panel
 */
export function transferexpand(): void {
  const expandedInput = getDomElement<HTMLInputElement>("transfer-expanded");
  if (!expandedInput) return;

  if (expandedInput.value === "0") {
    addClass("transfers", "transfers-expanded");
    expandedInput.value = "1";
    setHtml("transfers-expand2", '<i class="fas fa-chevron-down"></i>');
  } else {
    removeClass("transfers", "transfers-expanded");
    expandedInput.value = "0";
    setHtml("transfers-expand2", '<i class="fas fa-chevron-up"></i>');
  }
}

/**
 * Minimise transfers panel and save preference
 */
export function minimisetransfers(): void {
  hide("transfers");
  setCookie("TransMin", "1", 100000000000);
}

/**
 * Show transfers panel and save preference
 */
export function showtransfers(): void {
  setCookie("TransMin", "0", 100000000000);
  transfershow();
}

/**
 * Show transfers panel
 */
export function transfershow(): void {
  show("transfers");
  setTransferShow(1);
  void refreshTransfers();
}

registerActions({
  togglemobilemenu,
  transferexpand,
  minimisetransfers,
  showtransfers,
});
